import designService from "./designService";
import * as actions from "../actions";
import store from "../store";
import util from "../util";

const {setTemplateView, setTemplateGroups, setTemplateFamilies} = actions;

export function getPromoTemplates(size) {
  store.dispatch(setTemplateView('group'));
  store.dispatch(setTemplateGroups([], true));

  const sizeLabel = util.getSizeLabel(size);

  store.dispatch(actions.setSelectedFamily(sizeLabel));
  store.dispatch(actions.setSelectedCollection(''));

  designService.getTemplatesByStatusAndSizeGrouped(sizeLabel).then((response) => {
    store.dispatch(setTemplateGroups(response.data));
  }).catch(() => {
    store.dispatch(setTemplateGroups([], false));
  })

  // store.dispatch(setTemplateView('group'));
  // store.dispatch(setTemplateGroups([], true));

  // designService.getTemplatesGroupedByFamily().then(resp => {
  //   store.dispatch(setTemplateGroups(resp.data));
  // }).catch(() => {
  //   store.dispatch(setTemplateGroups([], false));
  // })
}